import React, { useState } from "react";
import TrainLoader from '../General/TrainLoader';
// Optional: if you create a CSS module, uncomment the next line
// import styles from "./designBuilds2026.module.css";

const DesignBuilds2026 = () => {
  const [loaded, setLoaded] = useState(false);

  const spinnerContainerStyle = {
    position: 'fixed', 
    top: '50%', 
    left: '50%', 
    transform: 'translate(-50%, -50%)',
    zIndex: 100,
  };

  return (
    <div style={{ width: "100%", height: "100%", minHeight: "100vh" }}>
      {!loaded && (
        <div style={spinnerContainerStyle}>
          <TrainLoader />
        </div>
      )}

      <iframe
        className="airtable-embed"
        src="https://airtable.com/embed/app17qjhRJ89EQqXs/shrhow1pHquUrhRrm"
        frameBorder="0"
        width="100%"
        height="100%"
        style={{ background: "transparent", border: "1px solid #ccc" }}
        title="2026 Design-Builds"
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};

export default DesignBuilds2026;
